module.exports = __webpack_public_path__ + "img/suipeople.4da1ce30.png";